<div class="e-feedback-form" role="main">
    <h1 class="e-page-title">Send us your feedback</h1>

    <form [formGroup]="contactUsFormGroup" (ngSubmit)="onSubmit(contactUsFormGroup.value)">
        <div class="e-form-group">
            <div>
                <label for="name" class="e-form-label">Name</label>
                <input type="text" id="name" [value]="userData.name" disabled />
            </div>
            <div>
                <label for="email" class="e-form-label">Your email address</label>
                <input type="text" id="email" [value]="userData.email" disabled />
            </div>
        </div>

        <div class="e-form-group">
            <div>
                <strong class="e-topic-label" id="topicLabel">What would you like to contact us about?</strong>
            </div>
            <div>
                <mat-form-field appearance="fill">
                    <mat-select required formControlName="topic"
                        panelClass="e-mat-select-panel e-contact-panel"
                        aria-labelledby="topicLabel"
                    >
                        <mat-option *ngFor="let topic of topics" [value]="topic">
                            {{ topic }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <p class="e-recipient-text">
                    You're sending this message to:<br />
                    <strong>{{ emailBasedOnTopic }}</strong>
                </p>
            </div>
        </div>

        <div class="e-form-group e-message-group">
            <div>
                <label for="message" class="e-form-label">Message here</label>
                <textarea formControlName="message" id="message"></textarea>
            </div>
        </div>

        <div class="e-form-button-group">
            <span aria-live="polite" *ngIf="showResponse" [ngClass]="isSuccessful ? 'e-message-success' : 'e-message-error'">
                {{ response }}
            </span>
            <button mat-button color="primary" type="submit">Send</button>
        </div>
    </form>

</div>
